import _ from 'lodash'

export const progress = state => key => {
    return _.get(state.progress, key, false)
}

export const patientsById = state => {
    return _.keyBy(state.patients, 'id')
}